import { CollectionOrigin, ColorTokenInlineData, ObjectMeta } from "@supernova-studio/model";
import { z } from "zod";

export const DTOTokenCollection = z.object({
  id: z.string(),
  persistentId: z.string(),
  designSystemVersionId: z.string(),

  meta: ObjectMeta,
  backgroundColor: ColorTokenInlineData.optional(),
  elementPropertyOptionId: z.string(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),

  origin: CollectionOrigin.optional(),
});

export const DTOTokenCollectionsListReponse = z.object({
  collections: DTOTokenCollection.array(),
});

export type DTOTokenCollection = z.infer<typeof DTOTokenCollection>;
export type DTOTokenCollectionsListReponse = z.infer<typeof DTOTokenCollectionsListReponse>;
